import "../../../field.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.VisitStep ??= {};

AppointmentBooking.Wizard.Views.VisitStep.AgeRangeField = class AgeRangeField extends (
  AppointmentBooking.Wizard.Views.Field
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    this.listenTo(this.model, "change:provider", this.render);
    return this.listenTo(this.model, "change:visit_type_id", this.render);
  }
};
AppointmentBooking.Wizard.Views.VisitStep.AgeRangeField.prototype.template = "step/visit/fields/age_range";
AppointmentBooking.Wizard.Views.VisitStep.AgeRangeField.prototype.className =
  "appointment-booking-wizard-visit-step-age-range-field";
